import React from 'react'
import { map, filter } from 'lodash'
import Select from 'UI/Select'

const DisableColumns = ({ columns, disableColumns }) => (
  <div className="row mb-3">
    <div className="col-8">
      <label>Disabled columns</label>
      <Select
        isMulti
        options={map(columns, column => ({ value: column.accessor, label: column.Header }))}
        onChange={options => disableColumns(filter(columns, column => !map(options, option => option.value).includes(column.accessor)))}
      />
    </div>
  </div>
  )

export default DisableColumns
